import { Table, TableRow, TableCell, TableHeader } from '@kvass/rich-text'

export default {
  stateKey: 'table',
  order: 9,
  commandKey: 'insertTable',
  commandProps: { rows: 3, cols: 3, withHeaderRow: true },
  icon: ['far', 'table'],
  extension: [
    Table.configure({
      resizable: true,
      HTMLAttributes: {
        class: 'rich-text-table',
      },
    }),
    TableRow,
    TableHeader,
    TableCell,
  ],
  appearance: {
    menu: true,
    bubble: false,
  },
  controls: [
    { command: 'addColumnBefore', icon: 'kvass:table-add-col-left' },
    { command: 'addColumnAfter', icon: 'kvass:table-add-col-right' },
    { command: 'deleteColumn', icon: 'kvass:table-remove-col' },
    { separator: true },
    { command: 'addRowBefore', icon: 'kvass:table-add-row-top' },
    { command: 'addRowAfter', icon: 'kvass:table-add-row-bottom' },
    { command: 'deleteRow', icon: 'kvass:table-remove-row' },
    { separator: true },
    { command: 'mergeCells', icon: 'kvass:table-merge-cells' },
    { command: 'splitCell', icon: 'kvass:table-umerge-cells' },
    { separator: true },
    { command: 'deleteTable', icon: ['far', 'trash'], requiresConfirmation: true },
  ],
}
